import {
    SET_GET_INSTANCES_REQUEST,
    SET_GET_INSTANCES_SUCCESS,
    SET_GET_INSTANCES_ERROR,
    SET_SELECT_INSTANCE,

    SET_GET_AVAILABLE_INSTANCES_REQUEST,
    SET_GET_AVAILABLE_INSTANCES_SUCCESS,
    SET_GET_AVAILABLE_INSTANCES_ERROR,

    SET_ALL_AVAILABLE_DOCKERS_REQUEST,
    SET_ALL_AVAILABLE_DOCKERS_SUCCESS,
    SET_ALL_AVAILABLE_DOCKERS_ERROR,

 } from './../../../constants/closeLoop/apmDashboard/instancesConstants';

const initialState = {
    loading: false,
    error: "",
    selectedInstance: "",
    instances: []
};

export const instanceReducer = (state=initialState, action) => {
    switch(action.type) {
        case SET_GET_INSTANCES_REQUEST:
            return {
                ...state,
                loading: true,
                error: ""
            }

        case SET_GET_INSTANCES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                instances: action.payload
            }

        case SET_GET_INSTANCES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case SET_SELECT_INSTANCE:
            return {
                ...state,
                loading: false,
                selectedInstance: action.payload
            }

        default:
            return state;
    }
};


const instanceInitialState = {
    loading: false,
    error: "",
    availableInstances: []
};

const randomId = () => { return Math.random().toString(36).substr(2, 9); }

const formatDataStructure = (info, count=6) => {
    const results = [];
    let prevIndex = 0;
    info.forEach((item, index, arr) => {
        const newIndex = index + 1;
        if(newIndex % count === 0) {
            results.push({id: randomId(), values: arr.slice(prevIndex, newIndex)});
            prevIndex = newIndex;
        } else if(info.length === newIndex && newIndex % count !== 0) {
            results.push({id: randomId(), values: arr.slice(prevIndex, info.length)});
        }
    });

    return results;
};


export const availableInstanceReducer = (state=instanceInitialState, action) => {
    switch(action.type) {
        case SET_GET_AVAILABLE_INSTANCES_REQUEST:
            return {
                ...state,
                loading: true,
                error: ""
            }

        case SET_GET_AVAILABLE_INSTANCES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: "",
                availableInstances: formatDataStructure(action.payload)
            }

        case SET_GET_AVAILABLE_INSTANCES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
};


const availableDockersState = {
    loading: false,
    error: '',
    info: {}
};

export const getAllDockersReducer = (state=availableDockersState, action) => {
    switch(action.type) {
        case SET_ALL_AVAILABLE_DOCKERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                info: []
            }

        case SET_ALL_AVAILABLE_DOCKERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                info: formatDataStructure(action.payload, 2)
            }

        case SET_ALL_AVAILABLE_DOCKERS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                info: []
            }

        default:
            return state;
    }
};